<template>
  <section class="logIn-popUp">
    <el-row class="mobile-version-el-row">
      <el-col :span="10" class="image-mobile">
        <div class="logIn-background">
          <img
            alt="logIn"
            class="logIn-bg mobile-login"
            src="../../../assets/images/mobile/logIn-registration-mobile.png"
          />
          <img
            alt="logIn"
            class="logIn-bg desktop-login"
            src="../../../assets/images/logIn-registration.png"
          />
        </div>
      </el-col>
      <el-col :span="14" class="image-mobile">
       <div  v-if="favoriteFlats.length" class="show"> ДЛЯ ЗБЕРЕЖЕННЯ ПІДБІРКИ УВІЙДІТЬ АБО ЗАРЕЄСТРУЙТЕСЬ </div>
        <div class="logIn-tabs-wrapper">
          <el-tabs v-model="activeName">
            <el-tab-pane label="Увійти" name="login">
              <el-form class="logIn-form-wrapper">
                <div class="logIn-form-inputs-wrapper">
                  <el-form-item
                    class="your-phone-wrapper custom-form-input"
                    :class="{ invalid: $v.loginForm.phone.$error }"
                  >
                    <el-input
                      v-model="loginForm.phone"
                      type="tel"
                      minlength="10"
                      maxlength="10"
                      placeholder=""
                      ><template slot="prepend">+38</template></el-input
                    >
                    <div class="your-label">ваш телефон</div>
                  </el-form-item>
                  <el-form-item
                    class="your-password-wrapper custom-form-input"
                    :class="{ invalid: $v.loginForm.password.$error }"
                  >
                    <el-input
                      placeholder=""
                      v-model="loginForm.password"
                      show-password
                    ></el-input>
                    <small
                      class="error-message"
                      v-if="
                        $v.loginForm.password.$error &&
                        !$v.loginForm.password.minLength
                      "
                      >Пароль має містити мінімум
                      {{ $v.loginForm.password.$params.minLength.min }}
                      символів</small
                    >
                    <div class="your-label">ваш пароль</div>
                  </el-form-item>
                </div>
                <div class="logIn-form-btn-wrapper">
                  <button
                    type="button"
                    class="rounded-btn blue"
                    :disabled="loading"
                    @click="loginUser"
                  >
                    {{ loading ? 'Зачекайте...' : 'Увійти' }}
                  </button>
                  <a href="" @click="forgotPassword">Забули пароль?</a>
                </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="Зареєструватись" name="register">
              <el-form
                name="logIn"
                class="registration-form-wrapper"
                autocomplete="off"
              >
                <div class="logIn-form-inputs-wrapper">
                  <el-form-item
                    class="your-phone-wrapper custom-form-input"
                    :class="{
                      invalid: $v.registerForm.phone.$error || errors.phone,
                    }"
                  >
                    <el-input
                      v-model="registerForm.phone"
                      type="tel"
                      minlength="10"
                      maxlength="10"
                      placeholder=""
                    >
                      <template slot="prepend">+38</template>
                    </el-input>
                    <div class="your-label">ваш телефон</div>
                  </el-form-item>
                  <el-form-item
                    class="your-password-wrapper custom-form-input"
                    :class="{ invalid: $v.registerForm.password.$error }"
                  >
                    <el-input
                      placeholder=""
                      v-model="registerForm.password"
                      show-password
                    ></el-input>
                    <small
                      class="error-message"
                      v-if="
                        $v.registerForm.password.$error &&
                        !$v.registerForm.password.minLength
                      "
                      >Пароль має містити мінімум
                      {{ $v.registerForm.password.$params.minLength.min }}
                      символів</small
                    >
                    <div class="your-label">ваш пароль</div>
                  </el-form-item>
                </div>
                <div class="logIn-form-btn-wrapper">
                  <div class="personal-info-accept check-box-input-global">
                    <el-checkbox v-model="personalInfoAccept"></el-checkbox>
                    <span>Згода на обробку </span>
                    <a href="">персональних даних</a>
                  </div>
                  <button
                    type="button"
                    @click="registerUser"
                    :disabled="!personalInfoAccept || loading"
                    class="rounded-btn blue"
                  >
                    {{ loading ? 'Зачекайте...' : 'Зареєструватись' }}
                  </button>
                </div>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
    </el-row>
  </section>
</template>
<script>
import { minLength, required, numeric } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { Api } from '@/services/AxiosService'
export default {

  computed: {
    ...mapGetters({
      favoriteFlats: 'getFavoriteFlatList',
    })},

  name: 'LogInPopUp',
  components: {},
  data() {
    return {
      activeName: 'login',
      phoneInput: '',
      passwordInput: '',
      personalInfoAccept: false,
      loading: false,
      registerForm: {
        phone: '',
        password: '',
      },
      loginForm: {
        phone: '',
        password: '',
      },
      errors: {},
    }
  },
  validations: {
    registerForm: {
      phone: { required, numeric, minLength: minLength(10) },
      password: { required, minLength: minLength(8) },
    },
    loginForm: {
      phone: { required, numeric, minLength: minLength(10) },
      password: { required, minLength: minLength(8) },
    },
  },
  methods: {
    async registerUser() {
      try {
        this.$v.registerForm.$touch()
        if (this.$v.registerForm.$invalid) {
          return
        }
        this.loading = true
        const POST = {
          ...this.registerForm,
          phone: '+38' + this.registerForm.phone,
          password_confirmation: this.registerForm.password,
        }
        await this.$store.dispatch('registerUser', POST)
        this.$v.registerForm.$reset()
        this.registerForm = {
          phone: '',
          password: '',
        }
        this.activeName = 'login'
        this.$emit('close')
        //delay before opening next modal
        setTimeout(() => this.$emit('code-confirm'), 300)
      } catch (e) {
        this.errors = e
        setTimeout(() => (this.errors = {}), 4000)
        const message = e.hasOwnProperty('phone')
          ? 'Введений номер телефону вже існує'
          : 'Перевірте ваші дані'
        this.$errorMessage(message)
      } finally {
        this.loading = false
      }
    },
    
    async loginUser() {
      try {
        this.$v.loginForm.$touch()
        if (this.$v.loginForm.$invalid) {
          return
        }
        this.loading = true
        const POST = {
          phone: '+38' + this.loginForm.phone,
          password: this.loginForm.password,
        }
        await this.$store.dispatch('loginUser', POST)
        if(this.favoriteFlats.length) await Promise.all(
          this.favoriteFlats.map((item) => Api.addToFavoriteFlatList(item.id,this.sortResponse(item.is_sort_up,item.is_sort_down))))
        location.reload()
      } catch (e) {
        this.$errorMessage('Перевірте ваші дані')
      } finally {
        this.loading = false
      }
    },
    sortResponse(up,down){
      if(up)  return 'top' 
      if(down) return 'bottom' 
      return 'normal'
    },
    forgotPassword(e) {
      e.preventDefault()
      this.$emit('close')
      //delay before opening next modal
      setTimeout(() => this.$emit('forgot-password'), 300)
    },
  },
  
}

</script>
